module.exports = __webpack_public_path__ + "img/archived.91d1a6e8.svg";